import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getUsers } from "../auth/actions/userActions";

export function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const company = useSelector((state) => state.user.company);

  useEffect(() => {
    async function fetchUsers() {
      if (!company?.unitId) return;

      setLoading(true);
      try {
        const response = await getUsers(null, company.unitId);

        if (response?.users && Array.isArray(response.users)) {
          setUsers(response.users);
        } else {
          setUsers([]);
        }
      } catch (error) {
        setUsers([]);
      } finally {
        setLoading(false);
      }
    }

    fetchUsers();
  }, [company?.unitId]);

  return { users, loading };
}
